<template>
	<tbody class="process-info-unit">
		<slot name="top-record" :large_process="large_process" />
		<!-- TODO schedule_arrangementに対応するように変更すること -->
		<ShowDetailRecord
			:tdStyle="tdStyle"
			:thStyle="thStyle"
			:fontSize="fontSize"
			:columnName="'工程名'"
			:value="large_process.large_process_type.name"
			:showEditBtn="showEditBtn"
			@open-edit-dialog="$emit('click-edit-btn', large_process)"
		/>
		<template v-if="large_process.large_process_type.schedule_arrangement_flag">
			<ShowDetailRecord
				:tdStyle="tdStyle"
				:thStyle="thStyle"
				:fontSize="fontSize"
				:columnName="'参加者'"
			>
				<template v-slot:value>
					<!-- TODO 参加者一覧 -->
					<div v-for="user in scheduleArrangementUsers" :key="user.id">
						{{ user.user.full_name }} ({{ user.confirmation_status_i18n }})
					</div>
				</template>
			</ShowDetailRecord>
			<ShowDetailRecord
				:tdStyle="tdStyle"
				:thStyle="thStyle"
				:fontSize="fontSize"
				:columnName="`${large_process.large_process_type.name}実行想定範囲`"
			>
				<template v-slot:value>
					{{
						common.formatLocalDateWithDay(large_process.schedule_arrangement.estimated_start_date)
					}}から
					<br />
					{{
						common.formatLocalDateWithDay(large_process.schedule_arrangement.estimated_end_date)
					}}まで
				</template>
			</ShowDetailRecord>
			<ShowDetailRecord
				:tdStyle="tdStyle"
				:thStyle="thStyle"
				:fontSize="fontSize"
				:columnName="`工程開始予定日時`"
				:value="
					common.formatLocalDateTimeWithDay(large_process.schedule_arrangement.planned_start_time)
				"
			/>
			<ShowDetailRecord
				:tdStyle="tdStyle"
				:thStyle="thStyle"
				:fontSize="fontSize"
				:columnName="`工程終了予定日時`"
				:value="
					common.formatLocalDateTimeWithDay(large_process.schedule_arrangement.planned_end_time)
				"
			/>
		</template>
		<template v-else>
			<ShowDetailRecord
				:tdStyle="tdStyle"
				:thStyle="thStyle"
				:fontSize="fontSize"
				:columnName="'工程開始予定時間(生産企画)'"
				:value="
					common.formatLocalDateWithNullableTime(
						large_process,
						'planned_start_date',
						'planned_start_time'
					)
				"
				@open-edit-time-dialog="
					$emit('click-edit-btn', {
						large_process,
						dateTimeKey: 'planned',
					})
				"
			/>
			<ShowDetailRecord
				:tdStyle="tdStyle"
				:thStyle="thStyle"
				:fontSize="fontSize"
				:columnName="'工程完了予定時間(生産企画)'"
				:value="
					common.formatLocalDateWithNullableTime(
						large_process,
						'planned_end_date',
						'planned_end_time'
					)
				"
				@open-edit-time-dialog="
					$emit('click-edit-btn', {
						large_process,
						dateTimeKey: 'planned',
					})
				"
			/>
			<ShowDetailRecord
				:tdStyle="tdStyle"
				:thStyle="thStyle"
				:fontSize="fontSize"
				:columnName="'工程開始予定時間(製造)'"
				:value="
					common.formatLocalDateWithNullableTime(
						large_process,
						'schedule_start_date',
						'schedule_start_time'
					)
				"
				@open-edit-time-dialog="
					$emit('click-edit-btn', {
						large_process,
						dateTimeKey: 'schedule',
					})
				"
			/>
			<ShowDetailRecord
				:tdStyle="tdStyle"
				:thStyle="thStyle"
				:fontSize="fontSize"
				:columnName="'工程完了予定時間(製造)'"
				:value="
					common.formatLocalDateWithNullableTime(
						large_process,
						'schedule_end_date',
						'schedule_end_time'
					)
				"
				@open-edit-time-dialog="
					$emit('click-edit-btn', {
						large_process,
						dateTimeKey: 'scheduled',
					})
				"
			/>
		</template>
		<ShowDetailRecord
			:tdStyle="tdStyle"
			:thStyle="thStyle"
			:fontSize="fontSize"
			:columnName="'工程開始時間'"
			:value="common.formatLocalDateWithNullableTime(large_process, 'start_date', 'start_time')"
			@open-edit-time-dialog="$emit('click-edit-btn', { large_process, dateTimeKey: 'result' })"
		/>
		<ShowDetailRecord
			:tdStyle="tdStyle"
			:thStyle="thStyle"
			:fontSize="fontSize"
			:columnName="'工程完了時間'"
			:value="common.formatLocalDateWithNullableTime(large_process, 'end_date', 'end_time')"
			@open-edit-time-dialog="$emit('click-edit-btn', { large_process, dateTimeKey: 'result' })"
		/>
		<ShowDetailRecord
			:tdStyle="tdStyle"
			:thStyle="thStyle"
			:fontSize="fontSize"
			:columnName="'状況'"
			:value="large_process.situation_i18n"
		/>
		<ShowDetailRecord
			:tdStyle="tdStyle"
			:thStyle="thStyle"
			:fontSize="fontSize"
			v-for="value in large_process.large_process_values"
			:columnName="
				value.large_process_column.status == 'archived'
					? `${value.large_process_column.name}(アーカイブ済み)`
					: value.large_process_column.name
			"
			:key="value.id"
			:value="common.value(value.large_process_column, value.value)"
			:text="value.large_process_column.data_type == 'text'"
		/>
		<ShowDetailRecord
			:tdStyle="tdStyle"
			:thStyle="thStyle"
			:fontSize="fontSize"
			:columnName="'特記事項'"
			:value="large_process.memo"
			text
		/>
		<ShowDetailRecord
			:tdStyle="tdStyle"
			:thStyle="thStyle"
			:fontSize="fontSize"
			:columnName="'添付ファイル'"
			:value="fileValue"
			:pStyle="pStyle"
			html
		>
			<template v-slot:value>
				<!-- TODO -->
				<div v-for="file in large_process.files" :key="file.id">
					<a :href="file.url" target="_blank">{{ file.name }}</a>
				</div>
			</template>
		</ShowDetailRecord>
		<slot name="bottom-record" :large_process="large_process" />
		<tr height="8px" />
	</tbody>
</template>

<script>
import common from "../../../helper/common"
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"
export default {
	props: {
		large_process: {
			type: Object,
			required: true,
		},
		tdStyle: {
			type: Object,
			required: false,
			default: () => ({}),
		},
		thStyle: {
			type: Object,
			required: false,
			default: () => ({}),
		},
		fontSize: {
			type: String,
			required: false,
			default: "",
		},
		showEditBtn: {
			default: false,
		},
	},
	components: {
		ShowDetailRecord,
	},
	data() {
		return {
			common,
			pStyle: { whiteSpace: "pre-line", wordBreak: "break-all" },
		}
	},
	methods: {
		replaceUrlWithLink(attached_file) {
			return `<a href="${attached_file.url}" target="_blank">${attached_file.name}</a>`
		},
	},
	computed: {
		scheduleArrangementUsers() {
			// TODO confirmation_statusで絞り込み
			const accepted_users =
				this.large_process.schedule_arrangement.schedule_arrangement_users.filter((user) => {
					return (
						user.confirmation_status == "accepted" ||
						user.confirmation_status == "pending" ||
						user.confirmation_status == "rejected"
					)
				})
			return accepted_users
		},
		fileValue() {
			let td_text = ""
			const urlPattern = /((http|https):\/\/[^\s]+)/g
			if (this.large_process.attached_files && this.large_process.attached_files.length) {
				this.large_process.attached_files.forEach((attached_file) => {
					if (attached_file.url) {
						td_text +=
							attached_file.url.replace(urlPattern, this.replaceUrlWithLink(attached_file)) + "\n"
					}
				})
			}
			return td_text
		},
	},
	watch: {
		large_process(newVal) {
			this.large_process = newVal
		},
		deep: true,
	},
}
</script>

<style lang="scss" scoped>
.process-info-unit {
	&:not(:first-child) {
		margin-top: 0.5rem;
	}
}
</style>
